import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { BannerI } from './models';

export const getBanner = () =>
  Axios.get<CommonTypes.RestfulResponse<BannerI>>(`${apiUrl}/banner`);
